module.exports = __webpack_public_path__ + "img/cont-03-tutela.d747a253.svg";